// @flow
export type Locale = string;

export type LocalesApiItem = string;

export default function modelLocale(item: LocalesApiItem): Locale {
  return item;
}



// WEBPACK FOOTER //
// ./src/redux/models/locale.js